import { DinamikBilesen } from '@service/fikoyt-ui/decorators/dinamik-bilesen';
import { DepartmanEditComponent } from './departman-edit.component';
import { DepartmanKartComponent } from './departman-kart.component';
import { DepartmanKartSadeComponent } from './departman-kart-sade.component';

@DinamikBilesen({
  id: 'departman',
  baslik: 'Departman',
  aciklama: 'Departman oluştur ve yönet',
  ikon: 'apartment',
  kategori: 'personel',
})
class Departman {
  paylas_kutusu = DepartmanEditComponent;
  paylasilmis_kart = DepartmanKartComponent;
  paylasilmis_kart_sade = DepartmanKartSadeComponent;
}
